import { render } from "./LoginPage.vue?vue&type=template&id=b4fca014&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=b4fca014&scoped=true&lang=css"

import exportComponent from "/Users/kaho/cloudfit-pro-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4fca014"]])

export default __exports__